export const MOTORCYCLE_ID = '61b097dab81c640012075885';
